import CodingSheet from "../components/CodingSheet";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useApi } from "../hooks/useApi";

function SitesList() {
    const initialized = useRef(false);
    const { siteId } = useParams();  // Get the site ID from the URL
    const [siteData, setSiteData] = useState(null);
    const { apiCall } = useApi();

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            // Fetch site details from API using the ID
            apiCall(`fetch_site`, { params: { site_id: siteId } })
                .then(response => response.json())
                .then(data => setSiteData(data))
                .catch(error => console.error("Error fetching site data:", error));
        }
    }, [siteId]);
    return (
        <>
            <div className="justify-center p-6">
                <h1 className="text-2xl font-bold mb-3">Monthly Invoicing</h1>
                {siteData ?
                    <div className="flex justify-between items-center mb-10">
                        <h1 className="text-2xl font-bold uppercase">{siteData.site_number} - {siteData.site_name}</h1>
                    </div>
            : <p>Loading...</p>}
            <CodingSheet/>
        </div >


        </>
    );
}

export default SitesList;